import React from 'react';
import emailjs from 'emailjs-com';

const ContactMe = () => {

    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm('service_ug2sjsu', 'template_6rkj4dw', e.target, 'ZLtj6O7hZys2axAHf')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
    };

    return (
        <div className='bg-gray-600 h-screen lg:ml-48'>
            <h2 className='text-2xl text-orange-400 text-cneter my-8'>Contact With Me</h2>
            <form className=' w-full flex flex-col justify-center items-center' onSubmit={sendEmail}>
            <div class="form-control w-full max-w-xs lg:mr-2">
                <label class="label ">
                    <span class="label-text text-orange-400">Your Name</span>
                </label>
                <input name="name" type="text" class="input input-bordered w-full max-w-xs" required />
            </div>
            <div class="form-control w-full max-w-xs lg:mr-2">
                <label class="label ">
                    <span class="label-text text-orange-400">Subject</span>
                </label>
                <input name="subject" type="text" class="input input-bordered w-full max-w-xs" required />
            </div>
            <div class="form-control w-full max-w-xs lg:mr-2">
                <label class="label">
                    <span class="label-text text-orange-400">Your Email</span>
                </label> 
                <input name="email" type="email" class="input input-bordered w-full max-w-xs" required />
            </div>
            <div class="form-control w-full max-w-xs lg:mr-2">
                <label class="label">
                    <span class="label-text text-orange-400">Your Message</span>
                </label>
                <textarea name="message" type="email" class="textarea textarea-bordered" required></textarea>
            </div>
            <input className='btn btn-md btn-orange-400 mt-2 text-orange-400' type="submit" value="Send" />
        </form>
        </div>
    );
};

export default ContactMe;